
import Clipboard from 'clipboard'
import XHeader from 'vux/src/components/x-header/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'


export default {
  name: 'app',
  directives: {
    TransferDom
  },
  components: {
    XHeader,
    ButtonTab,
    ButtonTabItem,
    Group,
    Cell,
    Flow,
    FlowState,
    FlowLine,
    XImg,
    XInput,
    XButton,
    XTable,
    Previewer,
    XDialog,
    Checker,
    CheckerItem
  },
  data () {
    return {
      loadFile: this.$route.query.loadFile,
      fileSrc: '',
      styleObject: {},
      fileName: this.$route.query.fileName
    }
  },
  mounted () {
    console.log('seeFile', this.loadFile)
    this.fileSrc = this.$store.state.url + '/static/pdf/web/viewer.html?file=' + this.loadFile
    this.getHeight()
  },
  methods: {
    getHeight () {
      let bodyH = document.body.clientHeight
      let iframeH = bodyH - 45 + 26
      this.styleObject = {
        width: '100%',
        height: iframeH + 'px'
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/page/Seefile.vue